import {
    instance
} from '../../util/http'
import apis from '../../config/apis'


// 店长列表
const list = (pageNo,pageSize) => {
    return instance.get(apis.partnerList.List + '?pageNo=' + pageNo + '&pageSize=' + pageSize)
}

export default {
    list
}